// EMPLOYMENT TYPES
const EmploymentTypesData = {
    ON_ROLL: 'On-Roll',
    DSA: 'DSA',
    RTO_AGENT: 'RTO Agent',
    USED_CAR_DEALER: 'Used Car Dealer',
    OUTSOURCE_THIRD_PARTY:'Out Source Third Party'
};

export const EMPLOYMENT_TYPES = {};

export const EMPLOYMENT_TYPES_LIST = Object.keys(EmploymentTypesData).map((key) => {
    EMPLOYMENT_TYPES[key] = key;

    return {
        value: key,
        label: EmploymentTypesData[key],
    };
});

// USER TYPES
const UserTypesData = {
    SUPER_ADMIN: 'Super Admin',
    ADMIN: 'Admin',
    MANAGER_INTERNAL: 'Manager – Internal',
    ASSISTANT_MANAGER_INTERNAL: 'Assistant Manager – Internal',
    TEAM_LEADER: 'Team Leader',
    FIELD_SUPERVISOR: 'Field Supervisor',
    FIELD_EXECUTIVE: 'Field Executive',
    MIS_BACK_OFFICE: 'MIS Back Office',
    AUDIT_EXECUTIVE: 'Audit Executive',
    CONSULTANT: 'Consultant',
    CLIENT_REPRESENTATIVE: 'Client Representative',
};

export const USER_TYPES = {};

export const USER_TYPES_LIST = Object.keys(UserTypesData).map((key) => {
    USER_TYPES[key] = key;

    return {
        value: key,
        label: UserTypesData[key],
    };
});

// DEPARTMENTS
const DepartmentData = {
    PERSONAL_BANKING_OPERATIONS: 'Personal Banking & Operations',
    DIGITAL_BANKING_DEPARTMENT: 'Digital Banking Department',
    RETAIL_BANKING_MARKETING_DEPARTMENT: 'Retail Banking & Marketing Department',
    WEALTH_MANAGEMENT_THIRD_PARTY_PRODUCTS: 'Wealth Management & Third Party Products',
    INTERNATIONAL_BANKING_DIVISION_DFB: 'International Banking Division & DFB',
    TREASURY: 'Treasury',
    INFORMATION_TECHNOLOGY: 'Information Technology',
    CORPORATE_COMMUNICATIONS: 'Corporate Communications',
    SUPPORT_SERVICES_BRANCH_EXPANSION: 'Support Services & Branch Expansion',
    HUMAN_RESOURCES: 'Human Resources',
    LARGE_CORPORATE_LOAN_SYNDICATION: 'Large Corporate & Loan Syndication',
    MSME_MICRO_SMALL_MEDIUM_ENTERPRISES: 'MSME (Micro Small & Medium Enterprises)',
    RURAL_AGRI_BUSINESS: 'Rural & Agri Business',
    FINANCIAL_INCLUSION: 'Financial Inclusion',
    LAW_DEPARTMENT: 'Law Department',
    CREDIT_RECOVERY_DEPARTMENT: 'Credit Recovery Department',
    RISK_MANAGEMENT_DEPARTMENT: 'Risk Management Department',
    CENTRAL_AUDIT_INSPECTION_DEPARTMENT: 'Central Audit & Inspection Department',
    CREDIT_MONITORING_AND_RESTRUCTURING_DEPARTMENT: 'Credit Monitoring and Restructuring Department',
    COMPLIANCE_DEPARTMENT: 'Compliance Department',
    BUSINESS_PROCESS_TRANSFORMATION: 'Business Process Transformation',
    CENTRAL_ACCOUNTS_FPIR: 'Central Accounts & FPIR',
    GOVT_BUSINESS_DEPT: 'Govt. Business Dept.',
};

export const DEPARTMENTS = {};

export const DEPARTMENTS_LIST = Object.keys(DepartmentData).map((key) => {
    DEPARTMENTS[key] = key;

    return {
        value: key,
        label: DepartmentData[key],
    };
});

// DESIGNATION
export const DesignationTypesData = {
    SR_MANAGER: 'Sr. Manager',
    MANAGER: 'Manager',
    EXECUTIVE: 'Executive',
};

export const DESIGNATION_TYPES = {};

export const DESIGNATION_TYPES_LIST = Object.keys(DesignationTypesData).map((key) => {
    DESIGNATION_TYPES[key] = key;

    return {
        value: key,
        label: DesignationTypesData[key],
    };
});

// FIRM TYPE
export const firmTypesData = {
    PROPRIETARY: 'Proprietary',
    PARTNER_SHIP: 'Partner Ship',
    PVT_LTD: 'Pvt. Ltd.',
};

export const FIRM_TYPES = {};

export const FIRM_TYPES_LIST = Object.keys(firmTypesData).map((key) => {
    FIRM_TYPES[key] = key;

    return {
        value: key,
        label: firmTypesData[key],
    };
});

// POLICY TYPES
const PolicyTypesData = {
    SOD: 'SOD Policy',
    THIRD_PARTY: '3rd Party Policy',
    // Add other policy types here if necessary
};

export const POLICY_TYPES = {};

export const POLICY_TYPES_LIST = Object.keys(PolicyTypesData).map((key) => {
    POLICY_TYPES[key] = key;

    return {
        value: key,
        label: PolicyTypesData[key],
    };
});


export default {
    POLICY_TYPES_LIST,
    EMPLOYMENT_TYPES,
    EMPLOYMENT_TYPES_LIST,
    USER_TYPES,
    USER_TYPES_LIST,
    FIRM_TYPES,
    FIRM_TYPES_LIST,
};
